import { useEffect, useState } from "react";
import { fetchPublicAnnouncements } from "../api/announcements";

// Dedupes concurrent identical requests the same way usePublicJobOpenings
// does, in case the notice mounts more than once on the same page.
let inFlight = null;

function loadPublicAnnouncements() {
  if (!inFlight) {
    inFlight = fetchPublicAnnouncements().finally(() => {
      inFlight = null;
    });
  }
  return inFlight;
}

export function usePublicAnnouncements() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    (async () => {
      try {
        const res = await loadPublicAnnouncements();
        if (cancelled) return;
        setItems(Array.isArray(res?.data) ? res.data : []);
      } catch {
        if (!cancelled) setItems([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return { items, loading };
}
